import { IDialogAction } from './IDialogAction';
import { DialogSignalRService } from '../services/DialogSignalRService';
import { DialogState } from '../models/DialogState';

export const REMOVE_MESSAGE = 'REMOVE_MESSAGE';

export class RemoveMessageAction implements IDialogAction {
    public readonly type = REMOVE_MESSAGE;
    public constructor(public payload: any, private _service?: DialogSignalRService) { }
    public middleware(): any {
        if (this._service) {
            this._service.deleteMessage(this.payload.id);
        }
        return;
    }
    public reducer(state: DialogState): DialogState {
        if (state.feed.messages)
            state.feed.messages.splice(state.feed.messages.findIndex(m => m.id === this.payload.id), 1);
        return state;
    }
}

export const RemoveMessageActionTypeMapping = {
    [REMOVE_MESSAGE]: RemoveMessageAction
}